import { useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';

import {
  SET_ON_CONTINUE,
  SET_LOADING,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';

const DISABLE_USER = gql`
  mutation DisableUser($id: ID!) {
    disableUser(id: $id) {
      message
    }
  }
`;

type DisableUserProps = {
  id: string;
  dispatchAction: (action: any) => void;
  usersQuery: any;
};

export default function DisableUser({
  id,
  dispatchAction,
  usersQuery,
}: DisableUserProps) {
  const [revokeTokens, { loading, error, called, data }] = useMutation(
    DISABLE_USER,
    {
      refetchQueries: [usersQuery, 'users'],
    }
  );

  useEffect(() => {
    if (id && revokeTokens) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: () => revokeTokens({ variables: { id } }),
        },
      });
    }
  }, [dispatchAction, id, revokeTokens]);

  useEffect(() => {
    if (loading !== undefined) {
      dispatchAction({
        type: SET_LOADING,
        payload: { loading },
      });
    }
  }, [dispatchAction, loading]);

  useEffect(() => {
    if (called && data && !error) {
      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: 'User disabled successfully.',
        },
      });
    }
  }, [called, data, dispatchAction, error]);

  return (
    <div className="flex flex-col justify-center items center text-center space-y-4">
      {loading && <LoadingSpinner />}
      {error && <ErrorText message={error.message} />}
      {!loading && !error && (
        <>
          <p>
            This will sign the user out of all active sessions and mark their
            account as disabled so that they cannot sign in again.
          </p>
          <p>Would you like to continue?</p>
        </>
      )}
    </div>
  );
}
